// @flow

import React, { type ComponentType } from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../../helpers';
import Button from '../../button';
import InputComponent from '../input';
import type { ButtonProps } from '../../button/types';
import type { Theme } from '../../../types';

const SearchButton: ComponentType<ButtonProps> = styled<typeof Button, Theme>(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  font-size: 1rem;
  margin-bottom: 0;
  min-width: auto;
  height: 2.5rem;
  line-height: 1.2em;
  padding-left: 1em;
  padding-right: 1em;

  ${media.md(css`
    padding-left: 1.25em;
    padding-right: 1.25em;
    height: 3.125rem;
  `)}
`;

const Input: ComponentType<*> = styled<typeof InputComponent, Theme>(InputComponent)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
  flex-grow: 1;
  height: 2.5rem;

  ${media.md(css`
    height: 3.125rem;
  `)}
`;

const SearchContainer = styled<any, Theme>('form')`
  display: flex;
  flex-direction: row;
`;

type Props = {
  error?: boolean,
  valid?: boolean,
  value?: string,
  onSubmit: Function,
  onInputChange: Function,
  placeholder?: string,
  buttonText: string,
};

const Search = ({
  error = false,
  value = '',
  valid = false,
  onSubmit,
  onInputChange,
  placeholder = '',
  buttonText,
}: Props) => (
  <SearchContainer
    onSubmit={e => {
      e.preventDefault();
      onSubmit(value);
    }}
  >
    <Input
      onChange={e => onInputChange(e.target.value)}
      value={value}
      error={error}
      valid={valid}
      placeholder={placeholder}
    />
    <SearchButton
      caret={false}
      colors="default"
      size="small"
      variant="default"
    >
      {buttonText}
    </SearchButton>
  </SearchContainer>
);

Search.defaultProps = {
  value: '',
  placeholder: '',
  error: false,
  valid: false,
};

export default Search;
